import React from 'react'
import { connectCurrentRefinements } from 'react-instantsearch-dom'
import { Box, Button } from '@deseretbook/react-ui'
import PropTypes from 'prop-types'

/**
 * Lists current applied filters, and allows removing them
 *
 * @param {array} items - List of currently applied filters
 * @param {function} refine - Removes the passed value from filters
 *
 * @returns {function} React component
 */
const CurrentRefinementsComponent = ({ items, refine }) => {
  /**
   * Grabs all of the refinements that we should list
   * Some items will have an array of more items if there can be multiple results for a single attribute
   */
  const listItems = items
    .map((item) => {
      if ((item.items || []).length) {
        return item.items
      }

      return item
    })
    .flat()

  /**
   * Removes the clicked item from the list of applied filters
   * @param {function} value - The item that will be removed from filters
   */
  const handleClick = (value) => {
    refine(value)
  }

  /**
   * Formats the price value for convenience
   * Will state things like Free, above X, below y, or x - y
   *
   * @param {number} min - The minimum set value for price
   * @param {number} max - The maximum set value for price
   *
   * @returns {string} Easy to read label for price
   */
  const formatRange = ({ min, max }) => {
    let label = ''
    const isMinUndefined = min === undefined
    const isMaxUndefined = max === undefined

    if (min && isMaxUndefined) {
      label += `Above $${min}`
    } else if (max && isMinUndefined) {
      label += `Below $${max}`
    } else if (max === 0) {
      label += 'Free'
    } else if (!isMinUndefined && !isMaxUndefined) {
      label += `$${min} - $${max}`
    }

    return label
  }

  return (
    <Box isWrapped>
      {listItems.map(({ label = '', value, currentRefinement = null }) => (
        <Box key={label} marginRight={0.5} marginVertical={0.5} maxWidth={13}>
          <Button
            size="small"
            icon="close"
            isRounded
            onClick={() => {
              handleClick(value)
            }}
          >
            {currentRefinement &&
            (currentRefinement.min !== undefined || currentRefinement.max !== undefined)
              ? formatRange(currentRefinement)
              : label}
          </Button>
        </Box>
      ))}
    </Box>
  )
}

CurrentRefinementsComponent.propTypes = {
  refine: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      attribute: PropTypes.string,
      value: PropTypes.func,
      items: PropTypes.arrayOf(PropTypes.strings),
    }),
  ),
}

export const CurrentRefinements = connectCurrentRefinements(CurrentRefinementsComponent)
